export default "__VITE_ASSET__D9uu3YDc__"